import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { increaseQuizCount } from '~teacher/hook/useQuizLimit';
import { quizzesQueryKey } from '~teacher/hook/useQuizzes';

import {
  MergeQuizParams,
  MergeQuizResponse,
  mergeQuiz,
} from '../../api/quiz/mergeQuiz/mergeQuiz';

export function useMergeQuiz() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mergeQuiz,
    onSuccess: () => {
      increaseQuizCount(queryClient);
      queryClient.invalidateQueries(quizzesQueryKey.quiz);
    },
  });
}

export type UseMergeQuizFunction = UseMutateFunction<
  MergeQuizResponse,
  unknown,
  MergeQuizParams,
  unknown
>;
